import { Typography } from '@mui/material';
import parse from 'html-react-parser';
import { useEffect, useState } from 'react';
import { useAccessibility } from '../../../../Store/contexts/AccessibilityContext';
import { sxTitle } from '../../../../assets/styles/CommonSxProps';
import CircularProgressLoading from '../../../../components/Accessibility/CircularProgressLoading';
import VoltarButton from '../../../../components/Accessibility/VoltarButton';
import ModalFeedBack from '../../../../components/ModalFeedBack';
import { getRegrasDoReembolso } from '../../../../services/Financeiro/ReembolsoService';
import './styles.css';
import AudioLoadingDescription from '../../../../components/Accessibility/AudioLoadingDescription';
import PageTitle from '../../../../components/Accessibility/PageTitle';

const RegrasReembolso: React.FC = () => {

  const accessibility = useAccessibility();

  const [regrasReembolso, setRegrasReembolso] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(false);
  const [modalFeedback, setModalFeedback] = useState<null | {
    icon?: 'error' | 'success' | 'warning', title?: string, textButton?: string, subTitle?: string,
    closeAction: () => void, showButtonModal: boolean, buttonAction?: () => void
  }>(null);

  const fetchSimulation = async () => {
    setLoading(true);
    const response = await getRegrasDoReembolso();
    if (response?.status === 200) {
      setRegrasReembolso(response.data);
    } else {
      console.error(response);
      openModalError('Erro ao consultar regras de reembolso', 'Tente novamente em instantes.');
    }
    setLoading(false);
  }

  useEffect(() => {
    fetchSimulation();
  }, []);

  const openModalError = (title: string, subtitle: string) => {
    setModalFeedback({
      icon: 'error',
      title: title,
      subTitle: subtitle,
      textButton: 'Fechar',
      showButtonModal: true,
      closeAction: () => setModalFeedback(null),
      buttonAction: () => setModalFeedback(null)
    });
  }

  return (
    <>
      <div className='regras-reembolso-container'>
        <AudioLoadingDescription loading={loading} />
        {loading && <CircularProgressLoading />}
        <Typography component="h1" sx={sxTitle} style={accessibility.textTitleStyleAccessibility}>
          Regras de reembolso
        </Typography>
        <br />
        <span>
          {parse(regrasReembolso)}
        </span>
        <VoltarButton onClick={() => window.history.back()} description="Voltar para menu reembolso" />
      </div>
      <ModalFeedBack
        showModal={!!modalFeedback}
        handleShowModal={modalFeedback?.closeAction}
        title={modalFeedback?.title as string}
        subTitle={modalFeedback?.subTitle as string}
        icon={modalFeedback?.icon as 'success' | 'error' | 'warning'}
        showButtonModal={modalFeedback?.showButtonModal}
        textButton={modalFeedback?.textButton as string}
        handleButtonModal={modalFeedback?.buttonAction}
      />
    </>
  )
}

export default RegrasReembolso;